<div class="container-column section">
    <section>Upload</section>
</div>
<form [formGroup]="form">
    <div class="card-container card" style="overflow-y: auto;">
        <table>
            <tr>
                <td>Project:</td>
                <td>
                    <kendo-dropdownlist class="dropdown" [data]="filteredProjects" textField="projectname"
                        valueField="projectId" [style.width.px]="430" formControlName="project"
                        [filterable]="true"
                        (filterChange)="onProjectFilter($event)"
                        (valueChange)="getObjectsForProjects($event);clearObjects()" [style.height.px]="30">
                        <!-- (filterChange)="form.value.purchaseOrder.id = null;form.value.purchaseOrder.name = 'Select an Order No..'" -->
                    </kendo-dropdownlist>
                </td>
            </tr>
            <tr>
                <td>Order No.:</td>
                <td>
                    <div kendoTooltip [title]="roleDescription"> 
                        <kendo-dropdownlist class="dropdown"
                            [data]="filteredPortalObjects" textField="name" valueField="id" formControlName="purchaseOrder"
                            [style.width.px]="430" [style.height.px]="30" (selectionChange)="selectionChange($event)"
                            [filterable]="true"
                            (filterChange)="onOrderFilter($event)">
                        </kendo-dropdownlist>
                    </div>
                </td>
                <!-- <button kendoButton [svgIcon]="icons.plusIcon" (click)="newUpload()"
                    [disabled]="this.flag || (!this.form.get('project')?.value.projectId || !this.form.get('purchaseOrder')?.value.id) || this.form.get('uploadId')?.value || (this.form.get('project')?.value.projectname =='Rights Project' && this.form.get('purchaseOrder')?.value.name == 'View')">
                    New Upload
                </button> -->

                <!--<button class="allbuttons" kendoButton [svgIcon]="icons.plusIcon" (click)="newUpload()"
                    [disabled]="this.flag || data.length > 0 || !this.form.get('project')?.value.projectId || !this.form.get('purchaseOrder')?.value.id">
                    New Upload
                </button>-->
                
                
                <button class="allbuttons" kendoButton [svgIcon]="icons.plusIcon" 
                    (click)="newUpload()" 
                    [disabled]="disableUpload()">
                    New Upload
                </button>

                <!-- <button class="allbuttons" kendoButton [svgIcon]="icons.saveIcon" (click)="saveUpload()"
                    style="width:60px"
                    [disabled]="saveButton || !this.form.get('project')?.value.projectId || !this.form.get('purchaseOrder')?.value.id">
                    Save
                </button> -->
                <!-- <span style=" position: absolute; right: 0px; padding-right: 100px;"> {{roleDescription}}</span> -->
            </tr>
        </table>
        <div>
            <table class="table">
                <tr>
                    <td>Upload ID:</td>
                    <td>
                        <kendo-textbox class="grey-out group-id" [style.width.px]="200"
                            style="pointer-events: none;opacity: 0.8;" [readonly]="true"
                            formControlName="uploadId"></kendo-textbox>
                    </td>
                    <td>Status:</td>
                    <td><kendo-textbox class="grey-out group-id" style="pointer-events: none;opacity: 0.8;"
                            [style.width.px]="200" [readonly]="true" formControlName="status"></kendo-textbox>
                    </td>
                    <td>Uploaded By:</td>
                    <td>
                        <kendo-textbox class="grey-out group-id" style="pointer-events: none;opacity: 0.8;"
                            [style.width.px]="200" [readonly]="true" formControlName="uploadedBy"></kendo-textbox>
                    </td>

                </tr>
                <tr>
                    <td>Date:</td>
                    <td>
                        <!-- <kendo-textbox class="grey-out group-id" style="pointer-events: none;opacity: 0.8;"
                            value="2023-04-08" [style.width.px]="200" [readonly]="true"
                            formControlName="uploadDate"></kendo-textbox> -->
                        <kendo-dateinput class="grey-out group-id" style="pointer-events: none;opacity: 0.8;" #longDate
                            format="dd-MMM-yyyy" [value]="dateValue" [style.width.px]="200" [readonly]="true"
                            formControlName="uploadDate" placeholder="">
                        </kendo-dateinput>
                    </td>
                    <td>Transmittal:</td>
                    <td><kendo-textbox class="grey-out group-id" [style.width.px]="200" formControlName="transmittal"
                            (valueChange)="onChange($event,'transmittal')"></kendo-textbox>
                    </td>

                    <td>Remarks:</td>

                    <td>

                        <div kendoTooltip>
                            <kendo-textbox class="grey-out group-id" [style.width.px]="200"
                                title="Maximum 255 characters" formControlName="remarks"
                                (valueChange)="onChange($event,'remark')">

                            </kendo-textbox>
                        </div>
                    </td>

                </tr>
            </table>
        </div>
        <div style="display: flex;">
            <div class="upload height" id="upload">
                <div class="container-column column-size25 upload-btn">
                    <div class="dropzone" #extdropzone kendoUploadDropZone="dropZone">
                        <kendo-upload #uploadcomp [autoUpload]="true" [saveUrl]="uploadSaveUrl"
                            [removeUrl]="uploadRemoveUrl" [withCredentials]="false"
                            (upload)="uploadEventHandler($event)" (success)="successfulUpload($event)" id="upload"
                            [disabled]="uploadCondition()" [chunkable]="chunkSettings" (select)="onSelect($event)"
                            (remove)="remove($event)" [ngModel]="files" (error)="onUploadError($event)"
                            [ngModelOptions]="{standalone: true}" zoneId="dropZone" (cancel)="cancel($event)">
                            <kendo-upload-messages select="Select Files..."
                                dropFilesHere="Drop files below to upload"></kendo-upload-messages>
                            <ng-template kendoFileSelectFileInfoTemplate let-files>
                                <div class="k-file-info">
                                    <span class="k-file-name">{{ files[0].name }}</span>
                                    <span class="k-file-size" *ngIf="files[0].state !== 0 && files[0].state !== 3">{{ files[0].filesize_to_display ?? formatFileSize(files[0].size) }}</span> 
                                    <span *ngIf="files[0].state === 3" class="k-file-summary upload-success">File successfully uploaded.</span>
                                    <span *ngIf="files[0].state === 0" class="k-file-summary upload-failed">File failed to upload.</span>
                                </div>
                            </ng-template>    
                        </kendo-upload>
                    </div>
                </div>
            </div>
            <div class="grid">
                <kendo-grid [kendoGridBinding]="uploadedFiles" class="upload-table" [style.min-height.px]="height"
                    [resizable]="true" [size]="smallSize" [sortable]="true" [reorderable]="true"
                    kendoGridSelectBy="file_id" [(selectedKeys)]="selection" [selectable]="{ mode: 'single'}">
                    <kendo-grid-column field="file_id" title="ID" [width]="50"></kendo-grid-column>
                    <kendo-grid-column field="filesize_to_display" title="Size" [width]="50"></kendo-grid-column>
                    <kendo-grid-column field="filename" title="Filename" [width]="150"></kendo-grid-column>
                    <kendo-grid-column field="uploaded_by" title="Uploaded By" [width]="100"></kendo-grid-column>
                    <kendo-grid-column field="upload_date" title="Upload Date" [width]="100"
                        format="dd-MMM-yyyy"></kendo-grid-column>
                    <kendo-grid-column field="status" title="Status" [width]="65"></kendo-grid-column>
                    <!-- <kendo-grid-column field="acknowledged" title="Acknowledged" [width]="80"></kendo-grid-column>
                    <kendo-grid-column field="processed" title="Processed" [width]="80"></kendo-grid-column>
                    <kendo-grid-column field="validated" title="Validated" [width]="80"></kendo-grid-column> -->
                </kendo-grid>
            </div>
        </div>
        <div style="margin-left: 27vw;font-size: small;margin-top: 5px;">{{uploadedFiles.length ? uploadedFiles.length :
            0}} {{'file(s)'}}</div>
        <!-- *ngIf="showAsActive()" -->
        <div class="declaration">
            <span>
                <input type="checkbox" formControlName="checkbox" [ngClass]="{'disable': checkboxCondition()}">
                <b>By checking this box you agree to the <a (click)="openeWindow = true;"><u>Terms &
                            Conditions</u></a>
                </b> </span>
            <div>
                <button class="allbuttons" style="margin-top: 10px;" kendoButton
                    [disabled]="!uploadedFiles.length || !form.value.checkbox || submitClicked" (click)="submit()">Submit</button>
            </div>
        </div>
    </div>
</form>
<div>
    <kendo-window title="Terms & Conditions" *ngIf="openeWindow" (close)="closeAccessWindow()" [width]="800"
        [height]="500" [resizable]="false" style="top: 0; left: 5%">
        <div>
            <p style="margin-bottom: 10px;">By uploading documents to the iDocs<sup>XD</sup> Portal (McDermott FTP
                site), you
                acknowledge and agree to the
                following terms:</p>

            <div style="margin: 0px 20px 10px 10px">
                <b>1. Document Ownership:</b> Upon clicking "Submit" and uploading your documents, you transfer
                ownership of
                these documents to McDermott International Ltd. and its subsidiaries (McDermott). These documents
                will be used for McDermott’s review and approval, and will be utilized in the delivery of the
                products or services specified in the Orders. Communications and information
                transmitted by, accessed through, or stored in this system belong to McDermott. Users have no
                expectation of privacy in relation to their use of and communications sent over McDermott's
                Information Systems (including this system), and their use may be monitored as set out in
                McDermott's Use of Company Communication Information Systems Policy IT-SEC-PL-00000.00 and
                applicable local policies (subject always to applicable local laws including data privacy laws).

            </div>
            <div style="margin: 0px 20px 10px 10px">
                <b>2. Security Compliance:</b> All uploaded documents must comply with McDermott's security
                policies. We
                will
                conduct a security scan on all documents uploaded to ensure they meet our standards. Further,
                McDermott may monitor the use of its systems, including reviewing login records, records of usage,
                and communications sent over its systems.

            </div>
            <div style="margin: 0px 20px 10px 10px">
                <b>3. Document Modifications:</b> If any changes are required to the uploaded documents, you must
                re-upload
                the revised documents through the iDocs<sup>XD</sup> Portal. Each new upload will be subject to the same
                ownership transfer and security compliance terms.
            </div>
            By proceeding with the upload, you confirm that you understand and accept these terms.
        </div>
        <div>
            <button class="k-dialog-content" (click)="closeAccessWindow()" type="button">Close</button>
        </div>
    </kendo-window>
</div>
<div>
    <kendo-dialog *ngIf="uploadFailed" title="Upload Failed" (close)="closeDialog()">
        <p style="margin: 10px; text-align: center;">A file with the same name already exists for this Upload ID. Please
            rename your file or choose a different file to upload.</p>
        <kendo-dialog-actions>
            <button class="k-dialog-content" (click)="closeDialog()">
                Close
            </button>
        </kendo-dialog-actions>
    </kendo-dialog>
</div>
<div>
    <kendo-dialog *ngIf="selectionFailed" title="Selection Failed" (close)="closeSelectionDialog()"
        [width]="selectionDialogWidth">
        <p style="margin: 10px; text-align: center;">{{ selectionErrorMessage }}</p>
        <kendo-dialog-actions>
            <button class="k-dialog-content" (click)="closeSelectionDialog()">
                Close
            </button>
        </kendo-dialog-actions>
    </kendo-dialog>
</div>
<div kendoDialogContainer></div>

<kendo-dialog *ngIf="showConfirmDialog" title="Confirm Navigation" (close)="onCancelLeave()" [width]="'580px'"  
    [height]="'190px'">
    <p *ngIf="uploadInProgress">Please wait—your file is still uploading. Leaving this page now may interrupt the
        upload process. </p>
    <p *ngIf="form.value.uploadId && !uploadInProgress">{{msg}}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="onCancelLeave()">Cancel</button>
        <button kendoButton class="allbuttons" (click)="onConfirmLeave()" themeColor="primary">Leave</button>
    </kendo-dialog-actions>
</kendo-dialog>

<!-- <ng-container kendoDialogContainer></ng-container> -->

<!-- Full-screen overlay -->
<div *ngIf="loading"
     class="overlay-backdrop">
  <div class="overlay-box">
    <span class="overlay-spinner" aria-hidden="true"></span>
    <div class="overlay-text">Submitting, please wait…</div>
  </div>
</div>